import React from 'react';
import Header from './../Header/Header'
import Footer from './../Footer/Footer'
import LoginForm from './LoginForm'

// Login stateless component
const Login = () =>
	<div>
		<Header />
		<section className="hero is-fullheight">
			<div className="hero-body">
				<div className="container">
					<div className="columns is-centered">
						<div className="column is-5-tablet is-4-desktop is-3-widescreen">
							<LoginForm />
						</div>
					</div>
				</div>
			</div>
		</section>
		<Footer />
	</div>

export default Login;



// WEBPACK FOOTER //
// ./src/components/Login/Login.js